var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "282px",
    height: "109.5px",
    viewBox: "0 0 282 109.5",
    enableBackground: "new 0 0 282 109.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B4A5D",
    d: "M92.812,19.963L92.812,19.963C91.605,7.804,70.249-0.031,45.108,2.463 C19.966,4.958,0.564,16.837,1.771,28.997l0,0L92.812,19.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B4A5D",
    d: "M189.188,19.963L189.188,19.963c1.207-12.159,22.563-19.994,47.705-17.5 c25.143,2.495,44.543,14.374,43.336,26.534l0,0L189.188,19.963z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompEyes);
export default __webpack_public_path__ + "static/media/comp_eyes.a04f9581622145c56ada844bcd0f2db6.svg";
export { ForwardRef as ReactComponent };